import * as giftGuidePageActions from '../../action_creators/gift_guide/gift_guide_page_action_creators';
import log from '../../../services/logger_service';

import asyncRecircFeedActions from '../async_recirc_feed_actions';
import asyncGiftGuideActions from './async_gift_guide_actions';
import asyncGiftGuideDetailsActions from './async_gift_guide_details_actions';

export default function fetchPersonPage(params, store) {
  return function firstDispatch(dispatch) {
    if (!params.category) {
      dispatch(giftGuidePageActions.giftGuidePageLoading({}, store));
    }
    return Promise.all([
      asyncGiftGuideDetailsActions(params, store)(dispatch),
      asyncGiftGuideActions(params, store)(dispatch),
      asyncRecircFeedActions(params, store)(dispatch)
    ])
      .then(function handlePostDetailData() {
        dispatch(giftGuidePageActions.giftGuidePageLoaded({}, store));
        return true;
      })
      .catch(function handleUserError(err) {
        dispatch(giftGuidePageActions.giftGuidePageLoadError(err, store));
        return log.error(
          err,
          `Error in tag page actions, message: ${err.message}`
        );
      });
  };
}
